export enum PaymentMethodType {
    Card = 0,
    BankAccount = 1,
    PayPal = 2,
    Bitcoin = 3,
}
